import { Image, Link, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowEduEvdListaEvidencijaHeader: React.FC<{
  verifikacijaEfikasnosti: string;
  imePrezime: string;
  radnoMjesto: string;
  verifikacijaPrisustvaPotpis: string;
  verifikacijaEdukatoraPotpis: string;
  dokument: string;
  tackaPrimjene: string;
}> = ({
  verifikacijaEfikasnosti,
  imePrezime,
  radnoMjesto,
  verifikacijaPrisustvaPotpis,
  verifikacijaEdukatoraPotpis,
  dokument,
  tackaPrimjene,
}) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tackaPrimjene}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{verifikacijaEfikasnosti}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{imePrezime}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{radnoMjesto}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{verifikacijaPrisustvaPotpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{verifikacijaEdukatoraPotpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{dokument}</Text>
    </View>
  </View>
);

export const TableRowEduEvdListaEvidencija: React.FC<{
  verifikacijaEfikasnosti: string;
  imePrezime: string;
  radnoMjesto: string;
  verifikacijaPrisustvaPotpis: string;
  verifikacijaEdukatoraPotpis: string;
  dokument?: string;
  slikaRes: string;
  tackaPrimjene: string;
}> = ({
  verifikacijaEfikasnosti,
  imePrezime,
  radnoMjesto,
  verifikacijaPrisustvaPotpis,
  verifikacijaEdukatoraPotpis,
  dokument,
  slikaRes,
  tackaPrimjene,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tackaPrimjene}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{verifikacijaEfikasnosti}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{imePrezime}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{radnoMjesto}</Text>
    </View>
    <View style={styles.tableCol}>
      {verifikacijaPrisustvaPotpis && (
        <Image
          style={[styles.tableCell, styles.signatureImage]}
          src={verifikacijaPrisustvaPotpis}
        />
      )}
    </View>
    <View style={styles.tableCol}>
      {verifikacijaEdukatoraPotpis && (
        <Image
          style={[styles.tableCell, styles.signatureImage]}
          src={verifikacijaEdukatoraPotpis}
        />
      )}
    </View>
    <View style={styles.tableCol}>
      {dokument && (
        <Link src={dokument} style={{ ...styles.tableCell, ...styles.link }}>
          {slikaRes}
        </Link>
      )}
    </View>
  </View>
);
